import { BN } from '@apps-orangefi/lib'
import axios from 'axios'

type FetchSYKPairQueryKey = {
  queryKey: [string, { chainKey: string | null; pairId: AddressType }[]]
}

type Pair = {
  chainId: string
  dexId: string
  url: string
  pairAddress: string
  baseToken: {
    address: string
    name: string
    symbol: string
  }
  quoteToken: {
    address: string
    name: string
    symbol: string
  }
  priceNative: string
  priceUsd: string
}

type DexscreenPairResult = {
  pair: Pair
}

export type DexPair = Omit<Pair, 'priceNative' | 'priceUsd'> & { priceNative: BN; priceUsd: BN }

const dexScreenerBaseUrl = 'https://api.dexscreener.com/latest/dex/pairs'

export const fetchDexPair = async ({ queryKey }: FetchSYKPairQueryKey): Promise<DexPair[]> => {
  const [_, paramsList] = queryKey

  const responseList = await Promise.all(
    paramsList.map(param => {
      const url = `${dexScreenerBaseUrl}/${param.chainKey}/${param.pairId}`
      return axios.get<DexscreenPairResult>(url, {})
    })
  )

  return responseList.map(res => {
    return {
      ...res.data.pair,
      priceNative: new BN(res.data.pair.priceNative),
      priceUsd: new BN(res.data.pair.priceUsd),
    }
  })
}
